module.exports = __webpack_public_path__ + "static/img/1_3_3.110c2815.jpg";